<template>
  <div class="payment-fail">
    <div class="fail-info-box">
               <div class="fail-icon">
                 <v-icon
                    large
                    color="red"
                    size="60"
                  >
                    mdi-alert-minus-outline
                  </v-icon>
               </div>
               <div class="fail-info-text">
                 <h6>Payment Failed</h6>
                 <p>{{msg}}</p>
               </div>
           </div>
  </div>
</template>
<script>
export default {
  name: "PaymentFail",
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
    const params = new URLSearchParams()
        // const params = new FormData()
    let queryString = this.$route.params.id

    this.msg = queryString;
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped>
.payment-fail{
  height: 100vh;
  background: #bc2626;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fail-info-box{
  
    background: white;
    border-radius: 10px;
    padding: 1rem 1rem 2rem;
    max-width: 500px;
    margin: 0 auto;
    text-align: center;
    width: 500px;

}
.fail-icon{
  .v-icon.v-icon{
    font-size: 180px!important;
    color: #ff556c;
  }
  margin-bottom: 1rem;
}
.fail-info-text{
  h6{
    margin-bottom: 1rem;
  }
}
</style>